//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import VueFroala from "@/assets/js/custom_libs/froala/vue-froala";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min";
import { generate, uuid } from "short-uuid";
import { $http } from "@/assets/js/appFunc";
import { defaultFonts } from "@/components/DocumentEditor/Froala/defaultDocument";
import { config } from "./config";

Vue.use(VueFroala);

export default {
    name: "FroalaComponent",
    inject: {
        eventBus: { default: () => null }
    },
    props: {
        height: {
            type: Number,
            default: 500
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        uuid: {
            type: String,
            default: ""
        },
        get: {
            type: String,
            default: ""
        },
        set: {
            type: String,
            default: ""
        },
        contentOnDemand: {
            type: Boolean,
            default: false
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ""
        },
        isProcessController: {
            type: Boolean,
            default: false
        },
        isLiveTesting: {
            type: Boolean,
            default: false
        },
        emitContent: { type: Boolean, default: false }
    },
    data() {
        return {
            config: {
                ...config,
                events: {
                    initialized: (vueInstance => function () {
                        vueInstance.froalaInstance = this;
                        this.vueInstance = vueInstance;
                        if (vueInstance.readOnly || !vueInstance.canEdit) {
                            this.edit.off();
                        }
                        if (!vueInstance.canEdit && !vueInstance.isLiveTesting) {
                            this.$tb.removeClass("fr-disabled");
                        }
                        if (vueInstance.isProcessController) {
                            this.$tb.hide();
                        } else {
                            vueInstance.loadContent();
                        }
                    })(this),
                    "image.inserted": function ($img, resp) {
                        const { filename, fileUUID, fileURL, local } = JSON.parse(resp);
                        $img[0].setAttribute("data-filename", filename);
                        $img[0].setAttribute("data-fileuuid", fileUUID);
                        $img[0].setAttribute("data-fileurl", fileURL);
                        $img[0].setAttribute("data-local", local);
                        $img[0].removeAttribute("filename");
                        $img[0].removeAttribute("fileuuid");
                        $img[0].removeAttribute("fileurl");
                        $img[0].removeAttribute("local");
                        this.events.trigger("contentChanged");
                    },
                    "image.resizeEnd": function () {
                        this.events.trigger("contentChanged");
                    }
                },
                heightMin: this.height - 32,
                heightMax: this.height + 2
            },
            id: generate(),
            froalaInstance: null,
            template: "",
            flow: {},
            contentRequested: false,
            fonts: defaultFonts(),
            showBlocks: false
        };
    },
    computed: {
        processInstanceId() {
            return this.flow && this.flow.hasOwnProperty("processInstanceId") ? this.flow.processInstanceId : null;
        }
    },
    watch: {
        height: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && this.froalaInstance) {
                    this.froalaInstance.$el.css("min-height", `${newVal - 32}px`);
                    this.froalaInstance.$wp.css("max-height", `${newVal + 2}px`);
                }
            }
        },
        content: {
            handler(newVal) {
                if (newVal) {
                    this.template = newVal;
                }
            },
            immediate: true
        },
        template: {
            handler(newVal) {
                if (!this.isLiveTesting) {
                    if (this.emitContent) {
                        this.$emit("contentUpdate", newVal);
                    }

                    if (!newVal) {
                        this.$emit("hasContent", false);
                    } else {
                        this.$emit("hasContent", true);
                    }
                }
            },
            immediate: true
        },
        canEdit: {
            handler(newVal) {
                if (newVal) {
                    if (!this.readOnly) {
                        this.froalaInstance.edit.on();
                    }
                } else {
                    this.froalaInstance.edit.off();
                }
            }
        },
        isLiveTesting: {
            handler(newVal) {
                if (newVal && this.readOnly) {
                    this.froalaInstance.$tb.addClass("fr-disabled");
                } else {
                    this.froalaInstance.$tb.removeClass("fr-disabled");
                }
            }
        }
    },
    created() {
        if (this.canEdit) {
            const localUuid = uuid();
            if (!this.uuid) {
                this.$emit("newUuid", localUuid);
            }
            this.eventBus.$emit("saveRichTextFunction", { fn: this.saveContent, uuid: this.uuid || localUuid });
        }
        let flow = localStorage.getItem("executionData");

        if (flow) {
            flow = JSON.parse(flow);
            this.flow = { ...flow };
        }

        let { host } = window.location;
        let { protocol } = window.location;

        if (host.indexOf("localhost") !== -1) {
            host = process.env.VUE_APP_ENV_PATH;
            protocol = "https:";
        }
        this.fonts = this.fonts.map(element => `${protocol}//${host}/fonts/${element}/${element}.css`);
    },
    mounted() {
        if (!this.contentOnDemand || !this.canEdit || this.isLiveTesting) {
            this.contentRequested = true;
        }
    },
    beforeDestroy() {
        this.eventBus.$emit("cancelSaveRichText", { uuid: this.uuid });
    },
    methods: {
        loadContent() {
            const formatUuid = typeof this.uuid === "string" ? this.uuid : null;
            if (!this.content && formatUuid && !this.isLiveTesting) {
                // setting img upload url here because we are sure we have a uuid and froala instance by now
                this.froalaInstance.opts.imageUploadURL = `/documents/templates/${formatUuid}/image/upload/`;

                const req = {
                    type: "GET",
                    url: `/engine/api/data/load/richtext/${formatUuid}`
                };
                $http(req, true).then(({ data }) => {
                    this.template = data.value;
                });
            }
        },
        saveContent() {
            // saving only if we tried to load and is not readonly
            if (this.contentRequested && !this.readOnly && !this.isLiveTesting && this.set) {
                const payload = {
                    id: this.uuid,
                    processInstanceId: this.processInstanceId,
                    variablePath: this.set,
                    value: this.template
                };

                const req = {
                    type: "POST",
                    url: "/engine/api/data/save/richtext",
                    data: payload
                };
                return $http(req, true).then(() => {});
            }
            return Promise.resolve();
        },
        toggleShowBlocks() {
            this.showBlocks = !this.showBlocks;
            return this.showBlocks;
        }
    }
};
